import { faTable } from '@fortawesome/pro-regular-svg-icons'
import {
  SectionWrapper,
  DetailInfo,
  DetailRow,
  ViewValueWithTruncate,
} from '@labrav/common'
import { useStyles } from './ViewDetailsResellerAuthorization.styles'
import type { MetaData } from '../../../modules/privateOffer/types'

export const CustomMetadataSection = ({
  metaData,
}: {
  metaData: MetaData[]
}) => {
  const { classes } = useStyles()
  return (
    <SectionWrapper
      heading="Custom metadata"
      icon={faTable}
      children={
        <div className={classes.metadata}>
          {metaData?.map(metaDataItem => (
            <DetailRow className={classes.metaDataItem}>
              <>
                <DetailInfo
                  title={'key'}
                  value={
                    <ViewValueWithTruncate value={metaDataItem?.key || ''} />
                  }
                />
                <DetailInfo
                  title={'value'}
                  value={
                    <ViewValueWithTruncate value={metaDataItem?.value || ''} />
                  }
                />
              </>
            </DetailRow>
          ))}
        </div>
      }
    />
  )
}
